import React from 'react';
import { Link } from 'react-router-dom';
import { COOKIE_SETTINGS_EVENT } from '../components/CookieConsent';
import '../App.css';

export default function AdatkezelesiTajekoztatoPage() {
  return (
    <main className="legal-page">
      <section className="section faq-full legal-page-inner">
        <nav className="svc-breadcrumb-trail legal-breadcrumb" aria-label="Útvonal">
          <Link className="svc-breadcrumb-seg" to="/">
            Főoldal
          </Link>
          <span className="svc-breadcrumb-sep" aria-hidden="true">
            /
          </span>
          <span className="svc-breadcrumb-current" aria-current="page">
            Adatkezelési tájékoztató
          </span>
        </nav>

        <h1>Adatkezelési tájékoztató</h1>
        <p className="legal-lead">
          Az alábbi szöveg tájékoztató jellegű vázlat. A végleges, jogász által jóváhagyott dokumentumot cseréld be
          a cég számára megfelelő tartalomra.
        </p>

        <h2>1. Az adatkezelő</h2>
        <p>
          Adatkezelő: <strong>ProfiTrans‑Mitter Kft.</strong> (Move and Parcel), székhely: 2119 Pécel, Határ u. 3.
          <br />
          Elérhetőség: <a href="mailto:office@moveandparcel.eu">office@moveandparcel.eu</a>,{' '}
          <a href="tel:+36706050279">+36 70 605 0279</a>.
        </p>

        <h2>2. Kezelt adatkör és cél</h2>
        <p>
          Ajánlatkérés és kapcsolatfelvétel során megadott név, e-mail cím, telefonszám és üzenet a kapcsolatfelvétel,
          ajánlatadás és szerződés előkészítése céljából kerül kezelésre. Az adatkezelés jogalapja: az érintett
          hozzájárulása (GDPR 6. cikk (1) bekezdés a) pont), illetve jogos érdek vagy szerződés teljesítése, ha
          alkalmazandó.
        </p>

        <h2>3. Megőrzés</h2>
        <p>
          Az adatokat a céllal összhangban, a kötelező jogi határidők figyelembevételével őrizzük meg, majd töröljük vagy
          anonimizáljuk.
        </p>

        <h2>4. Jogok</h2>
        <p>
          Kérelmezheted az adataidhoz való hozzáférést, helyesbítést, törlést, az adatkezelés korlátozását,
          adathordozhatóságot, illetve a hozzájárulás visszavonását. Panaszt tehetsz a Nemzeti Adatvédelmi és
          Információszabadság Hatóságnál (NAIH).
        </p>

        <h2>5. Sütik</h2>
        <p>
          A weboldal a működéshez szükséges sütiket és – a beállításaid szerint – opcionális, funkcionális, elemző és
          hirdetési sütiket használhat. A részletes beállításokat itt módosíthatod:
        </p>
        <p>
          <button
            type="button"
            className="legal-cookie-open"
            onClick={() => window.dispatchEvent(new CustomEvent(COOKIE_SETTINGS_EVENT))}
          >
            Sütibeállítások megnyitása
          </button>
        </p>

        <p className="legal-back">
          <Link to="/">← Vissza a főoldalra</Link>
        </p>
      </section>
    </main>
  );
}
